export enum EAutoCalibrationResult {
  CurrentAutoCalibration = 0,
  UpdatedAutoCalibration = 1,
}
